import { baseUrl } from "@/requestConfig/baseUrl";
import axios from "@/requestConfig/intercept";
import { Response } from "../index.limit";
import { ReqBindCustomerList, ReqCustomerBind, ReqCustomerList, ReqCustomerPageList, ReqZtInfoes, ResBindCustomerList, ResCustomerList, ResPageList, ResZtInfoes } from "./index.limit";
export * from "./index.limit";

const { api } = baseUrl;
/**
 * 获取可见客户列表
 * @returns
 */
export const apiCustomerlist = async (params: ReqCustomerList): Promise<Response<ResCustomerList[]>> => {
  return axios.get(`${api}/customer/customerlist`, { params });
};
/**
 * 分页获取可见客户列表
 * 关联客户弹窗用这个，别用上面的全量接口：大企业号四千多家客户，
 * 一次拿回来光渲染就要好几秒
 * @returns
 */
export const apiCustomerPagelist = async (params: ReqCustomerPageList): Promise<Response<ResPageList<ResCustomerList>>> => {
  return axios.get(`${api}/customer/customerpagelist`, { params });
};
/**
 * 获取当前外部联系人绑定的客户集合
 * @returns
 */
export const apiBindcustomerlist = (params: ReqBindCustomerList): Promise<Response<ResBindCustomerList[]>> => {
  return axios.get(`${api}/customer/bindcustomerlist`, { params });
};

/**
 * 企业成员关联客户
 * @returns
 */
export const apiCustomerBind = (data: ReqCustomerBind): Promise<Response<string>> => {
  return axios.post(`${api}/customer/customerbind`, data);
};

/**
 * 获取账套信息
 */
export const apiZtInfoes = (params: ReqZtInfoes): Promise<Response<ResZtInfoes[]>> => {
  return axios.get(`${api}/Financial/ZtInfoes`, { params });
};
